import React from 'react';

const Loading = () => (
  <p className="text-center loading-wrapper">
    <i className="fa fa-circle-o-notch fa-spin fa-2x fa-fw" />
  </p>
);

export default Loading;
